module.exports = __webpack_public_path__ + "static/img/年度最佳教育硬件.7af2699b.png";